import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export async function getBooking(payload: {
  userId?: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  scope?: "mine" | "all";
  organizationId?: string;
} = {}) {
  try {
    const page = payload.page ?? 0;
    const limit = payload.limit ?? 25;
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });
    if (payload.search) params.set("search", payload.search);
    if (payload.status) params.set("status", payload.status);
    if (payload.scope) params.set("scope", payload.scope);
    if (payload.userId) params.set("userId", payload.userId);
    if (payload.organizationId) {
      params.set("organizationId", payload.organizationId);
    }

    const callParams = await getCallParams("GET");
    return makeCall(`${urls.Booking}?${params.toString()}`, callParams);
  } catch (error) {
    throw error;
  }
}
